module.exports = "/assets/data/8e634c8274266602137637d313f9a73e-FK3.data.json";